module.exports = __webpack_public_path__ + "static/media/youtube-hcr-grey.c601628f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/youtube-hcr-grey.svg
// module id = 1487
// module chunks = 0